import React, { useEffect, useState } from 'react';
import Select from 'react-select';
// import DatePicker from 'react-datepicker';
import DatePicker from 'react-date-picker';
// import 'react-datepicker/dist/react-datepicker.css';
import '../../style/editablegrid.css';
import SelectSearch, { fuzzySearch } from "react-select-search";
import "../../style/select-search.css";
import configData from '../../configData.json';
import moment from 'moment';
import { getValidNumericValue, getValidDecimalValue } from '../Utlities';

export default function AccBillableItems({ sccData, onUpdateGridData, selectedCust, onDeleteRows }) {
    const [gridData, setGridData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemTypeOptions, setItemTypeOptions] = useState([]);
    const [cust, setCust] = useState(0);

    useEffect(() => {
        // debugger;
        setCust(selectedCust);
        if (Array.isArray(sccData)) {
            // debugger;
            const filteredNvisionServices = sccData.filter(
                service => service.serviceType === "BI"
            );
            setGridData(filteredNvisionServices);
        } else {
            setGridData([]);
        }
        // debugger;
        LoadItemDescriptions();

    }, [sccData]);

    useEffect(() => {
        onUpdateGridData(gridData);
    }, [gridData]);

    const LoadItemDescriptions = async () => {
        // debugger;
        setLoading(true);
        const serviceUrl = `${configData.BASE_APP_URL}CustomerSetup/GetItemDescription`;
        await fetch(serviceUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let itemOptions = [];
                resp.map(item => {
                    const ser = {
                        "name": item.codeDesc,
                        "value": item.codeID
                    }
                    itemOptions = [...itemOptions, ser];
                })
                const defaultItem = {
                    "name": "--Select A Value--",
                    "value": 0
                }
                itemOptions.unshift(defaultItem);
                setItemTypeOptions(itemOptions)

            })
        setLoading(false);
    };

    const handleServiceChange = (newValue, row) => {
        // debugger
        const selectedService = itemTypeOptions.find(option => option.value === newValue);

        if (selectedService) {
            setGridData(prevGridData => {
                const updatedData = prevGridData.map(item => {
                    if (item.id === row.id) {
                        const isServiceChanged = item.codeId !== selectedService.value;
                        let dirtyFlag = item.dirtyFlag;

                        if (row.isNew && isServiceChanged) {
                            dirtyFlag = 'I';
                        } else if (isServiceChanged) {
                            dirtyFlag = 'U';
                        }

                        return {
                            ...item,
                            codeId: selectedService.value,
                            codeDesc: selectedService.name,
                            dirtyFlag: dirtyFlag,
                            modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                            // modifiedOn: item.isNew ? '' : new Date().toISOString() // Update modifiedOn for existing rows
                        };
                    }
                    return item; // Only update the specific row, leave others unchanged
                });
                // debugger;
                onUpdateGridData(updatedData); // Update data immediately
                return updatedData;
            });
        }
    };

    const handleDateOfServiceChange = (newDate, row) => {
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {
                const isDateChanged = item.serviceDate !== newDate.toISOString();

                let dirtyFlag = item.dirtyFlag;

                if (row.isNew && isDateChanged) {
                    dirtyFlag = 'I';
                } else if (isDateChanged) {
                    dirtyFlag = 'U';
                }
                return {
                    ...item,
                    serviceDate: newDate.toISOString(),
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                    // modifiedOn: item.isNew ? '' : new Date().toISOString() // Update modifiedOn for existing rows
                };
            }
            return item;
        });

        // Update data immediately and notify parent component
        setGridData(updatedData);
        onUpdateGridData(updatedData);
    };

    const handleFirstPageTextChange = (newValue, row) => {
        debugger;
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {
                const isTextChanged = item.firstPageRate !== newValue;

                let dirtyFlag = item.dirtyFlag;

                if (row.isNew && isTextChanged) {
                    dirtyFlag = 'I';
                } else if (isTextChanged) {
                    dirtyFlag = 'U';
                }

                return {
                    ...item,
                    firstPageRate: getValidDecimalValue(newValue),
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                };
            }
            return item;
        });

        // Update data immediately and notify parent component
        setGridData(updatedData);
        onUpdateGridData(updatedData);
    };

    const handleFirstPageRangeChange = (newValue, row) => {
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {
                const isTextChanged = item.firstPageRange !== newValue;

                let dirtyFlag = item.dirtyFlag;

                if (row.isNew && isTextChanged) {
                    dirtyFlag = 'I';
                } else if (isTextChanged) {
                    dirtyFlag = 'U';
                }

                return {
                    ...item,
                    firstPageRange: getValidNumericValue(newValue),
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                };
            }
            return item;
        });

        // Update data immediately and notify parent component
        setGridData(updatedData);
        onUpdateGridData(updatedData);
    };

    const handleNextPageRateChange = (newValue, row) => {
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {
                const isTextChanged = item.nextPageRate !== newValue;

                let dirtyFlag = item.dirtyFlag;

                if (row.isNew && isTextChanged) {
                    dirtyFlag = 'I';
                } else if (isTextChanged) {
                    dirtyFlag = 'U';
                }

                return {
                    ...item,
                    nextPageRate: getValidDecimalValue(newValue),
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                };
            }
            return item;
        });

        // Update data immediately and notify parent component
        setGridData(updatedData);
        onUpdateGridData(updatedData);
    };

    const handleNextPageRangeChange = (newValue, row) => {
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {
                const isTextChanged = item.nextPageRange !== newValue;

                let dirtyFlag = item.dirtyFlag;

                if (row.isNew && isTextChanged) {
                    dirtyFlag = 'I';
                } else if (isTextChanged) {
                    dirtyFlag = 'U';
                }

                return {
                    ...item,
                    nextPageRange: getValidNumericValue(newValue),
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                };
            }
            return item;
        });

        // Update data immediately and notify parent component
        setGridData(updatedData);
        onUpdateGridData(updatedData);
    };

    const handleCommentsTextChange = (newValue, row) => {
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {
                const isTextChanged = item.comments !== newValue;

                let dirtyFlag = item.dirtyFlag;

                if (row.isNew && isTextChanged) {
                    dirtyFlag = 'I';
                } else if (isTextChanged) {
                    dirtyFlag = 'U';
                }

                return {
                    ...item,
                    comments: newValue,
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                };
            }
            return item;
        });

        // Update data immediately and notify parent component
        setGridData(updatedData);
        onUpdateGridData(updatedData);
    };


    const handleCheckboxChange = (checked, row) => {
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {
                return { ...item, checked };
            }
            return item;
        });
        setGridData(updatedData);
    };

    const generateNewRow = () => {
        const username = sessionStorage.getItem('my-username');
        const timestamp = new Date().getTime().toString(); // Use current timestamp as string

        return {
            id: timestamp, // Unique ID based on timestamp
            checked: false,
            customerKey: cust,
            codeId: '',
            productDesc: '',
            firstPageRate: '',
            firstPageRange: '',
            nextPageRate: '',
            nextPageRange: '',
            serviceType: "BI",
            createdBy: username,
            // createdOn: new Date().toISOString(),
            dirtyFlag: 'I',
            isNew: true,
            comments: ''
        };
    };

    const handleAddRow = () => {
        const newRow = generateNewRow();
        setGridData([...gridData, newRow]);
    };

    const handleDeleteRows = async () => {
        // Get the IDs of rows to be deleted
        debugger;
        const selectedRowIds = gridData.filter(row => row.checked && !row.isNew).map(row => row.id);

        if (selectedRowIds.length === 0) {
            // If no rows are selected for deletion, return early
            const updatedData = gridData.filter(row => !row.checked);
            setGridData(updatedData);
            onUpdateGridData(updatedData);
            const deletedRowCount = selectedRowIds.length;
            onDeleteRows(deletedRowCount);
            return;
        }

        // Prepare the request URL with customer_key and comma-separated IDs
        const customerKey = cust; // Use the 'cust' state for customer_key
        const idsToDelete = selectedRowIds.join(',');

        const apiUrl = `${configData.BASE_APP_URL}CustomerSetup/DeleteBillableItems?customerkey=${customerKey}&ids=${idsToDelete}`;

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            if (response.ok) {
                // Delete was successful, update the state and notify parent component
                window.alert('Data deleted successfully.');
                const updatedData = gridData.filter(row => !row.checked);
                setGridData(updatedData);
                onUpdateGridData(updatedData);
                const deletedRowCount = selectedRowIds.length;
                onDeleteRows(deletedRowCount);
                // window.confirm('Data deleted successfully.');
            } else {
                // Handle error response from the API if needed
                console.error('Error deleting rows:', response.statusText);
                window.alert('Error deleting data.');
            }
        } catch (error) {
            // Handle network or other errors if needed
            console.error('Error deleting rows:', error);
            window.alert('Error deleting data.');
        }
    };

    function formatDateTime(dateTime) {
        if (dateTime) {
            return new Date(dateTime).toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true,
                timeZone: 'UTC'
            });
        }
        return '';
    }

    function customFormatter(row) {
        debugger;
        return (
            <div className='text-center'>
                <div className="row align-items-center">
                    <div className="col-2">
                        Rate Per Page
                    </div>
                    <div className="col px-1">
                        <input style={{width: "50px"}} id="rateperpage"
                            value={row.firstPageRate !== null ? row.firstPageRate : null}
                            className="form-control form-control-sm"
                            onChange={e => handleFirstPageTextChange(e.target.value, row)}
                        >
                        </input>
                    </div>
                    <div className="col">
                        First
                    </div>
                    <div className="col px-1">
                        <input id="firstPageRange"
                            value={row.firstPageRange !== null ? row.firstPageRange : null}
                            className="form-control form-control-sm"
                            onChange={e => handleFirstPageRangeChange(e.target.value, row)}
                        >
                        </input>
                    </div>
                    <div className="col-3">
                        Number of Pages / Rate Per Page
                    </div>
                    <div className="col px-1">
                        <input style={{width: "50px"}} id="nextPageRate"
                            value={row.nextPageRate !== null ? row.nextPageRate : null}
                            className="form-control form-control-sm"
                            onChange={e => handleNextPageRateChange(e.target.value, row)}
                        >
                        </input>
                    </div>
                    <div className="col">
                        After
                    </div>
                    <div className="col px-1">
                        <input id="nextPageRange"
                            value={row.nextPageRange !== null ? row.nextPageRange : null}
                            className="form-control form-control-sm"
                            onChange={e => handleNextPageRangeChange(e.target.value, row)}
                        >
                        </input>
                    </div>
                    <div className="col-2">
                        Number of pages
                    </div>

                </div>



            </div>
        );
    }

    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id="headingFive">
                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                    Billable Items
                </button>
            </h2>
            <div id="collapseFive" className="accordion-collapse collapse show" aria-labelledby="headingFive" data-bs-parent="#accordionSettings">
                <div className="accordion-body">

                    <div className='custom-table-text accordian-table'>
                        <button className='btn btn-filter mb-2' onClick={handleAddRow}> <i className='fa fa-plus'></i> Add</button>
                        <button className='btn btn-clear ms-2 mb-2' onClick={handleDeleteRows}> <i className='fa fa-trash'></i> Delete</button>
                        <div className='react-bootstrap-table'>
                            <table className='table table-striped table-hover'>
                                <thead>
                                    <tr className='table-top'>
                                        <th className='center-align' width='30px'></th>
                                        <th className='center-align hidden-column' width='100px'>ItemID</th>
                                        <th className='center-align' width='200px'>Item Description</th>
                                        <th className='center-align' width='700px'>Item Logic</th>
                                        <th className='center-align' width='150'>Note</th>
                                        <th className='center-align' width='100px'>Created By</th>
                                        <th className='center-align' width='100px'>Created On</th>
                                        <th className='center-align' width='100px'>Modified By</th>
                                        <th className='center-align' width='100px'>Modified On</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {gridData.map((row, index) => (
                                        <tr
                                            key={row.id}
                                        >
                                            <td className='center-align'>
                                                <input
                                                    type='checkbox'
                                                    checked={row.checked}
                                                    onChange={e => handleCheckboxChange(e.target.checked, row)}
                                                />
                                            </td>
                                            <td className='center-align hidden-column'>{row.ItemID}</td>
                                            <td className='center-align'>
                                                <SelectSearch
                                                    id="ddnItem"
                                                    name="ddnItem"
                                                    className="select-search"
                                                    value={row.codeId}
                                                    options={itemTypeOptions}
                                                    onChange={newValue => handleServiceChange(newValue, row)}
                                                    search
                                                    filterOptions={fuzzySearch}

                                                >
                                                </SelectSearch>
                                            </td>
                                            <td className='center-align'>
                                                {customFormatter(row)}
                                            </td>
                                            <td className='center-align'>
                                                <textarea
                                                    rows="2"
                                                    value={row.comments}
                                                    onChange={e => handleCommentsTextChange(e.target.value, row)}
                                                />
                                            </td>
                                            <td className='center-align'>{row.createdBy ? row.createdBy.toUpperCase() : ''}</td>
                                            <td className='center-align'>{formatDateTime(row.createdOn)}</td>
                                            <td className='center-align'>{row.modifiedBy ? row.modifiedBy.toUpperCase() : ''}</td>
                                            <td className='center-align'>{formatDateTime(row.modifiedOn)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

